import React from 'react';
import { useTranslation } from '../App';

const Philosophy = () => {
  const t = useTranslation();
  return (
    <section className="flex plan" id="abt">
      <div className="plan-item">
        <img src="/assets/plan.svg" alt="Plan" className="plan-svg" />
      </div>
      <div className="plan-item plan-cont">
        <h3>{t.philosophy.heading}</h3>
        <p>{t.philosophy.description1}</p>
        <p>{t.philosophy.description2}</p>
      </div>
    </section>
  );
};

export default Philosophy;